module.exports = __webpack_public_path__ + "static/media/update.66d13260.svg";